import { apiClient } from '../config/api';

export class DashboardService {
  static async empresaOverview(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/empresa/${empresaId}${qs}`);
  }

  static async financeiroOverview(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/financeiro/${empresaId}${qs}`);
  }

  static async clientesOverview(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/clientes/${empresaId}${qs}`);
  }

  static async documentosOverview(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/documentos/${empresaId}${qs}`);
  }

  static async calculosOverview(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/calculos/${empresaId}${qs}`);
  }

  static async operacionalOverview(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/operacional/${empresaId}${qs}`);
  }

  // Novos endpoints por empresa
  static async parcelasOverview(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/parcelas/${empresaId}${qs}`);
  }

  static async sinistrosOverview(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/sinistros/${empresaId}${qs}`);
  }

  static async repassesOverview(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/repasses/${empresaId}${qs}`);
  }

  // Endpoints por grupo (consolidado)
  static async grupoOverview(grupoId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/grupo/${grupoId}${qs}`);
  }

  static async grupoParcelasOverview(grupoId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/grupo/${grupoId}/parcelas${qs}`);
  }

  static async grupoSinistrosOverview(grupoId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/grupo/${grupoId}/sinistros${qs}`);
  }

  static async grupoRepassesOverview(grupoId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    const qs = params ? '?' + new URLSearchParams(Object.entries(params).reduce((acc, [k, v]) => (v == null ? acc : { ...acc, [k]: String(v) }), {} as Record<string,string>)).toString() : '';
    return apiClient.request<any>(`/dashboard/grupo/${grupoId}/repasses${qs}`);
  }

  // Backward compatibility method
  static async empresaResumo(empresaId: string, params?: { year?: number; month?: number; from?: string; to?: string }) {
    return this.empresaOverview(empresaId, params);
  }
}

export const dashboardService = DashboardService;
